import React, { Component } from "react";
import { Redirect } from 'react-router-dom'
import { Alert, Button } from "react-bootstrap";
import axios from "axios";
import Logo from '../images/logo.png'
import CommonLoader from "./loaderComponent/CommonLoader";
import { validateLoginForm } from "../utils/validation";
import CommonToast from "./Toaster/CommonToast";
import LogIn from '../images/log-in.png'
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      checkPassword: "",
      passwordShow: false,
      hasError: false,
      errorMessage: "",
      done: false,
      errors: {},
      loading: true,
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: ''
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }


  passwordVisibilityHandler = () => {
    var x = document.getElementById("password");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  };

  onChange = (event) => {
    const { name, value } = event.target;
    let errors = { ...this.state.errors };
    if (name === "username" && value.trim()) {
      delete errors.username;
    }
    if (name === "password" && value.length >= 6) {
      delete errors.password;
    }
    this.setState({
      [name]: value,
      errors,
    });
  };

  componentDidMount = () => {
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 500);
  }

  onSubmit = async (event) => {
    this.setState({ loading: true });
    event.preventDefault();

    const errors = validateLoginForm(this.state.username, this.state.password);
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }

    const user = {
      username: this.state.username,
      password: this.state.password,
    };

    try {
      const res = await axios.post("/login", user);
      const token = res?.data?.token;
      localStorage.setItem('token', token);
      this.setState({
        done: true,
        showToast: true,
        toastMessage: res?.data?.message || 'Login successful!',
        toastVariant: 'success',
        color: 'green',
      });

      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
        this.props.history.push("/");
      }, 900);
    } catch (err) {
      console.error(err.response);
      this.setState({
        hasError: true,
        showToast: true,
        toastVariant: 'danger',
        color: 'red',
        toastMessage: err?.response?.data?.message,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 900);
    }
  };
  // onSubmit = (event) => {
  //   this.setState({
  //     loading: true,
  //   })
  //   event.preventDefault();
  //   const errors = validateLoginForm(this.state.username, this.state.password);
  //   if (Object.keys(errors).length > 0) {
  //     this.setState({ errors, loading: false });
  //     return;
  //   }
  //   var user = {
  //     username: this.state.username,
  //     password: this.state.password,
  //   };
  //   axios({
  //     method: "post",
  //     url: "/login",
  //     data: user,
  //   })
  //     .then((res) => {
  //       localStorage.setItem('token', res?.data?.token)
  //       this.setState({
  //         done: true,
  //         showToast: true,
  //         toastMessage: res?.data?.message || ' Login successful!',
  //         toastVariant: 'success',
  //         color: 'green',
  //       })
  //       setTimeout(() => {
  //         this.setState({ loading: false, showToast: false });
  //         this.props.history.push("/");
  //       }, 900);
  //     })
  //     .catch((err) => {
  //       console.log(err.response);
  //       this.setState({
  //         hasError: true,
  //         loading: false,
  //         showToast: true,
  //         toastVariant: 'danger',
  //         color: 'red',
  //         toastMessage: err?.response?.data?.message,
  //         // errorMessage: err?.response?.data?.message
  //       });
  //       setTimeout(() => {
  //         this.setState({ loading: false, showToast: false });
  //       }, 900);
  //     });
  // };




  render() {
    return (
      <>
        <CommonLoader isLoading={this.state.loading}>
          <div className="register-box">
            <div className="register-logo">
              <a>
                {/* {this.state.done ? <Redirect to="/" /> : <></>} */}
                <img src={Logo} lat="broken_Logo" width={200} alt="broken_image" />
                <small style={{ fontSize: "10px" }}></small>
              </a>
            </div>
            <div className="card">
              <div className="card-body register-card-body">
                {/* {this.state.hasError ? (
                <Alert variant="danger">{this.state.errorMessage}</Alert>
              ) : null} */}
                <h4 className="login-box-msg login-heading">Login</h4>
                <form onSubmit={this.onSubmit}>
                  <div>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="username"
                        placeholder="Username/Email"
                        value={this.state.username}
                        onChange={this.onChange}
                      // required
                      />
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span className="fas fa-user" />
                        </div>
                      </div>
                    </div>
                    <span className="login-error">
                      {this.state.errors.username && <small className="text-danger">{this.state.errors.username}</small>}
                    </span>
                    <div className="input-group">
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        id="password"
                        placeholder="Password"
                        value={this.state.password}
                        onChange={this.onChange}
                      // required
                      />
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span className="fas fa-lock" />
                        </div>
                      </div>
                      <div className="input-group-append">
                        <div className="input-group-text login">
                          <span
                            className={
                              this.state.passwordShow
                                ? "fas fa-eye"
                                : "fas fa-eye-slash"
                            }
                            onClick={this.passwordVisibilityHandler}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="login-error">
                    {this.state.errors.password && <small className="text-danger">{this.state.errors.password}</small>}
                  </span>
                  <div className="row">
                    <div className="col-8"></div>
                    {/* /.col */}
                    {/* <div className="col-12">
                      <button type="submit" variant='outline-primary' className="btn btn-primary btn-block">
                        Login
                      </button>
                    </div> */}
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-outline-primary w-100 py-2 px-4 rounded-pill fw-semibold shadow-sm"
                      >
                        <i className="bi bi-box-arrow-in-right me-2"></i> Login
                      </button>
                    </div>

                    {/* <div className="col-12">
                      <button type="submit" className="btn btn-primary btn-block d-flex align-items-center justify-content-center gap-2">

                        <img
                          className="login_image"
                          src={LogIn}
                          alt="broken"
                          style={{ width: '30px', height: '30px' }}
                        />
                      </button>
                    </div> */}
                    {/* /.col */}
                  </div>
                </form>
                {/* <a href="/register" className="text-center mt-1">
              Don't have an account? Register
            </a>
            <hr className="mt-3" /> */}
              </div>
              {/* /.form-box */}
            </div>
            {/* /.card */}
          </div>

        </CommonLoader>

        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
      </>
    );
  }
}
